<div class="main-container">
  <p class="content">{{data}}</p>
  <p class="content text-center" *ngIf="!data">No data found!</p>
</div>